// extracted by mini-css-extract-plugin
export default {"sectionTitle":"RulesControls_sectionTitle__A2Yii","checkboxGroup":"RulesControls_checkboxGroup__UfDvf"};